import React from "react";

import { Layout, NFTStakingIncome } from "../components";

const NFTStakingIncomePage = () => {
  return (
    <>
      <Layout>
        <NFTStakingIncome />
      </Layout>
    </>
  );
};

export default NFTStakingIncomePage;
